import { getService } from 'data/function';
export class CommandProcessor {
    static get MessagingHubService() {
        return getService('MessagingHubService');
    }
    static get BlipService() {
        return getService('BlipService');
    }
    /**
     * Process command from postMessage event
     * @param payload
     */
    static async process({ message, trackingProperties, source }) {
        try {
            const service = message.content.destination === 'BlipService' ? 'BlipService' : 'MessagingHubService';
            const command = message.content && message.content.command;
            const timeout = message.content && message.content.timeout;
            const response = await CommandProcessor[service].sendCommand(command, timeout);
            const messageResponse = {
                response,
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
        }
        catch (e) {
            // TODO: handle error on iframe load in a single point
            const errorResponse = {
                error: JSON.stringify(e),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
    }
}
